const getters = {
    getShipmentDocumentTypes: (state) => {
        return state.shipmentDocumentTypes;
    },

    getUploadResponse: (state) => {
        return state.uploadResponse;
    }
};

export default getters;
